import React, { useState, useEffect, Fragment } from "react";
import IntlMessages from "../helpers/IntlMessages";
import "./../date-picker.css";
import { Calendar } from "react-modern-calendar-datepicker";
import moment from "moment";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { __esModule } from "reactstrap/lib/Col";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const BMB_BOOKING_ENGINE =
  process.env.REACT_APP_API_URL + "/booking-engine-data";
const Availability = process.env.REACT_APP_PARTNER_URL + "/";
let currentDate = moment().add(1, "days").format("YYYY-MM-DD");
function AmaduesAvailability({
  data,
  gid,
  pid,
  api,
  lang,
  integration,
  closeAvailblityForm,
  addLinks,
  buttonColor,
  roomdata
}) {
  const [promoCode, setPromoCode] = useState("");
  const [roomTypeCode, setRoomTypeCode] = useState("");
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [nights, setNights] = useState(0);
  const [children_age, setChildren_age] = useState([]);
  const [ratePlanCode, setRatePlanCode] = useState("");
  const [datesData, setDatesData] = useState([]);
  const [disableDays, setDisableDays] = useState([]);
  const [disableCheckInDate, setDisableCheckInDate] = useState([]);
  const [showModel, setShowModel] = useState(false);
  const [dates, setDates] = useState(null);
  const [minimumDate, setMinimumDate] = useState({
    year: moment().add(1, "days").year(),
    month: moment().add(1, "days").month() + 1,
    day: moment().add(1, "days").date(),
  });
  const [loading, setLoading] = useState(true);
  const defaultValue = {
    year: 2023,
    month: 12,
    day: 1,
  };
  const [selectedDayRange, setSelectedDayRange] = useState({
    from: null,
    to: null,
  });

  const handleDisableDaysChange = (
    fromDate,
    toDate,
    adults,
    children,
    roomTypeCode
  ) => {
    setLoading(true);
    if (moment(fromDate).format("MM") === moment().format("MM"))
      fromDate = moment().add(1, "days").format("YYYY-MM-DD");

    toDate = moment(toDate).add(1, "days").format("YYYY-MM-DD");
    setDisableDays([]);
    if (integration.Channel === 'Sabre' || integration.Channel === 'SHRCRS') {
      fetch(
        Availability +
        `public/availability/${integration.Id}/basic?group_id=` +
        gid +
        "&adults=" +
        adults +
        "&children=" +
        children +
        "&dateIn=" +
        moment(fromDate).format("YYYY-MM-DD") +
        "&dateOut=" +
        moment(toDate).format("YYYY-MM-DD") +
        "&roomType=" +
        roomTypeCode +
        "&propertyId=" +
        pid +
        "&ratePlanCode=" +
        "&channel=" + integration.Channel,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          handleFillCalender(json);
        });
    } else {
      fetch(
        Availability +
        "public/amadeus/searchamadues?gid=" +
        gid +
        "&pid=" +
        pid +
        "&adults=" +
        adults +
        "&children=" +
        children +
        "&dateIn=" +
        moment(fromDate).format("YYYY-MM-DD") +
        "&dateOut=" +
        moment(toDate).format("YYYY-MM-DD") +
        "&roomTypeCode=" +
        roomTypeCode +
        "",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          var elements = document.getElementsByClassName("Calendar__day");
          if (json.dates !== undefined) {
            if (elements !== undefined) {
              setDatesData(json.dates);
              let isCheckOutDate = true;
              for (let i = 0; i < elements.length; i++) {
                const obj = json.dates.filter(
                  (f) =>
                    elements[i].attributes["aria-label"].nodeValue ===
                    moment(f.date).format("dddd") +
                    ", " +
                    moment(f.date).format("D") +
                    " " +
                    moment(f.date).format("MMMM") +
                    " " +
                    moment(f.date).format("YYYY")
                );
                if (obj.length > 0) {
                  let discount = (obj[0].rate.discountOnLowestMinRate !== undefined &&
                    obj[0].rate.discountOnLowestMinRate > 0) ? obj[0].rate.discountOnLowestMinRate : 0;

                  let minRate = obj[0].rate.minRate;

                  let price = parseInt(Math.round(minRate - discount));

                  if (obj[0].isAvailable === true) {
                    isCheckOutDate = true;
                    let html = `<div class="custom_day"><p style="line-height:2em">${moment(
                      obj[0].date
                    ).format(
                      "D"
                    )}</p>${`<p style="font-size:0.75rem;">$${price}</p>`}</div>`;
                    elements[i].innerHTML = html;
                  } else if (isCheckOutDate === true) {
                    isCheckOutDate = false;
                    let html = `<div class="custom_day pb-0"><p class="mb-1">${moment(
                      obj[0].date
                    ).format(
                      "D"
                    )}</p>${`<p style="font-size:7.75px;padding-bottom:5px;">Check out only</p>`}</div>`;
                    elements[i].innerHTML = html;
                    let lst = disableCheckInDate;
                    lst.push({
                      year: moment(obj[0].date).format("YYYY"),
                      month: moment(obj[0].date).format("MM"),
                      day: moment(obj[0].date).format("D"),
                    });
                    setDisableCheckInDate(lst);
                  } else {
                    // if (showAvailabity === false && showRates === false) {
                    //   let html = `<div class="custom_day"><p class="mb-2">${moment(obj[0].date).format('D')}</p></div>`;
                    //   elements[i].innerHTML = html;
                    // }
                    // else if (showRates === false && showAvailabity === true) {
                    //   let html = `<div class="small-strikethrough"><p class="mb-2"><span style="line-height:2em">${moment(obj[0].date).format('D')}</span></p></div>`;
                    //   elements[i].innerHTML = html;
                    // }
                    // else if (showRates === true && showAvailabity === false) {
                    //   let html = `<div class="custom_day"><p class="mb-2"><span style="line-height:2em">${moment(obj[0].date).format('D')}</span></p></div>`;
                    //   elements[i].innerHTML = html;
                    // }
                    // else {
                    let html = `<div class="strikethrough"><p class="mb-2"><span style="line-height:3em">${moment(
                      obj[0].date
                    ).format("D")}</span></p></div>`;
                    elements[i].innerHTML = html;
                    //}
                    let lst = disableDays;
                    lst.push({
                      year: moment(obj[0].date).format("YYYY"),
                      month: moment(obj[0].date).format("MM"),
                      day: moment(obj[0].date).format("D"),
                    });
                    setDisableDays(lst);
                  }
                }
              }
            }
            setLoading(false);
          } else if (json.statusCode !== undefined && json.statusCode === 429) {
            setTimeout(() => {
              handleDisableDaysChange(
                currentDate,
                moment(currentDate).add(30, "days").format("YYYY-MM-DD"),
                adults,
                children,
                roomTypeCode
              );
            }, 10000);
          } else {
            setLoading(false);
          }
        });
    }
  };

  const handleFillCalender = (json) => {
    var elements = document.getElementsByClassName("Calendar__day");
    if (json.dates !== undefined) {
      if (elements !== undefined) {
        setDatesData(json.dates);
        let isCheckOutDate = true;
        for (let i = 0; i < elements.length; i++) {
          const obj = json.dates.filter(
            (f) =>
              elements[i].attributes["aria-label"].nodeValue ===
              moment(f.date).format("dddd") +
              ", " +
              moment(f.date).format("D") +
              " " +
              moment(f.date).format("MMMM") +
              " " +
              moment(f.date).format("YYYY")
          );
          if (obj.length > 0) {
            let price = parseInt(obj[0].price);
            if (obj[0].isAvailable === true) {
              isCheckOutDate = true;
              let html = `<div class="custom_day"><p class="mb-2">${moment(
                obj[0].date
              ).format(
                "D"
              )}</p>${`<p style="font-size:0.75rem;">$${price}</p>`}</div>`;
              elements[i].innerHTML = html;
            } else if (isCheckOutDate === true) {
              isCheckOutDate = false;
              let html = `<div class="custom_day pb-0"><p class="mb-1">${moment(
                obj[0].date
              ).format(
                "D"
              )}</p>${`<p style="font-size:7.75px;padding-bottom:5px;">Check out only</p>`}</div>`;
              elements[i].innerHTML = html;
              let lst = disableCheckInDate;
              lst.push({
                year: moment(obj[0].date).format("YYYY"),
                month: moment(obj[0].date).format("MM"),
                day: moment(obj[0].date).format("D"),
              });
              setDisableCheckInDate(lst);
            } else {
              let html = `<div class="strikethrough"><p class="mb-2"><span style="line-height:2em">${moment(
                obj[0].date
              ).format("D")}</span></p></div>`;
              elements[i].innerHTML = html;
              //}
              let lst = disableDays;
              lst.push({
                year: moment(obj[0].date).format("YYYY"),
                month: moment(obj[0].date).format("MM"),
                day: moment(obj[0].date).format("D"),
              });
              setDisableDays(lst);
            }
          } else if (elements[i].attributes["aria-label"].nodeValue.includes('undefined') === false
            && moment(elements[i].attributes["aria-label"].nodeValue).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')) {
            let html = `<div class="strikethrough"><p class="mb-2"><span style="line-height:2em">${moment(
              elements[i].attributes["aria-label"].nodeValue
            ).format("D")}</span></p></div>`;
            elements[i].innerHTML = html;
            //}
            let lst = disableDays;
            lst.push({
              year: moment(elements[i].attributes["aria-label"].nodeValue).format("YYYY"),
              month: moment(elements[i].attributes["aria-label"].nodeValue).format("MM"),
              day: moment(elements[i].attributes["aria-label"].nodeValue).format("D"),
            });
            setDisableDays(lst);
          }
        }
      }
      setLoading(false);
    } else if (json.statusCode !== undefined && json.statusCode === 429) {
      setTimeout(() => {
        handleDisableDaysChange(
          currentDate,
          moment(currentDate).add(30, "days").format("YYYY-MM-DD"),
          adults,
          children,
          roomTypeCode
        );
      }, 10000);
    } else {
      setLoading(false);
    }
  }


  useEffect(() => {
    currentDate = moment().add(0, "days").format("YYYY-MM-DD");
    const leftButton = document.getElementsByClassName(
      "Calendar__monthArrowWrapper"
    );
    const yearSelector = document.getElementsByClassName(
      "Calendar__yearSelector"
    );
    const monthSelector = document.getElementsByClassName(
      "Calendar__monthSelector"
    );
    if (leftButton.length > 1) {
      yearSelector[0].addEventListener("click", function handleClick(event) {
        let newDate = "";
        setTimeout(() => {
          const monthYear = document.getElementsByClassName(
            "Calendar__monthYear -shown"
          );
          const month = document.getElementsByClassName("Calendar__monthText");
          const year = document.getElementsByClassName("Calendar__yearText");
          if (monthYear.length > 0)
            newDate =
              monthYear[0].innerText?.split("\n")[1] +
              "-" +
              moment()
                .month(monthYear[0].innerText?.split("\n")[0])
                .format("MM")
                .toString() +
              "-" +
              "1";
          else
            newDate =
              year[0].innerText +
              "-" +
              moment().month(month[0].innerText).format("MM").toString() +
              "-" +
              "1";

          currentDate = newDate;
          let adult_count = document.getElementById("adult_count").value;
          let children_count = document.getElementById("children_count").value;
          let roomCode = document.getElementById("roomCode").value;
          handleDisableDaysChange(
            moment(newDate).format("YYYY-MM-DD"),
            moment(newDate).endOf("month").format("YYYY-MM-DD"),
            adult_count,
            children_count,
            roomCode
          );
        }, 1000);
      });
      monthSelector[0].addEventListener("click", function handleClick(event) {
        event.preventDefault();
        let newDate = "";
        setTimeout(() => {
          const monthYear = document.getElementsByClassName(
            "Calendar__monthYear -shown"
          );
          const month = document.getElementsByClassName("Calendar__monthText");
          const year = document.getElementsByClassName("Calendar__yearText");
          if (monthYear.length > 0)
            newDate =
              monthYear[0].innerText?.split("\n")[1] +
              "-" +
              moment()
                .month(monthYear[0].innerText?.split("\n")[0])
                .format("MM")
                .toString() +
              "-" +
              "1";
          else
            newDate =
              year[0].innerText +
              "-" +
              moment().month(month[0].innerText).format("MM").toString() +
              "-" +
              "1";
          currentDate = newDate;
          let adult_count = document.getElementById("adult_count").value;
          let children_count = document.getElementById("children_count").value;
          let roomCode = document.getElementById("roomCode").value;
          handleDisableDaysChange(
            moment(newDate).format("YYYY-MM-DD"),
            moment(newDate).endOf("month").format("YYYY-MM-DD"),
            adult_count,
            children_count,
            roomCode
          );
        }, 1000);
      });

      leftButton[0].addEventListener("click", function handleClick(event) {
        setTimeout(() => {
          let newDate = moment(currentDate)
            .subtract(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD");

          currentDate = newDate;
          let adult_count = document.getElementById("adult_count").value;
          let children_count = document.getElementById("children_count").value;
          let roomCode = document.getElementById("roomCode").value;
          handleDisableDaysChange(
            moment(newDate).format("YYYY-MM-DD"),
            moment(newDate).endOf("month").format("YYYY-MM-DD"),
            adult_count,
            children_count,
            roomCode
          );
        }, 1000);
      });

      leftButton[1].addEventListener("click", function handleClick(event) {
        setTimeout(() => {
          let newDate = moment(currentDate)
            .add(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD");
          currentDate = newDate;
          let adult_count = document.getElementById("adult_count").value;
          let children_count = document.getElementById("children_count").value;
          let roomCode = document.getElementById("roomCode").value;
          handleDisableDaysChange(
            moment(newDate).format("YYYY-MM-DD"),
            moment(newDate).endOf("month").format("YYYY-MM-DD"),
            adult_count,
            children_count,
            roomCode
          );
        }, 1000);
      });
    }

    if (integration.ShowRatesSelectedRoom === true) {
      var payload = {
        propertyId: data.pid,
        roomId: data.roomId,
        languageCode: "en",
      };

      fetch(process.env.REACT_APP_API_URL + "/room", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((json) => {
          setRoomTypeCode(json.result.providerRoomCode);
          handleDisableDaysChange(
            currentDate,
            moment(currentDate).add(30, "days").format("YYYY-MM-DD"),
            adults,
            children,
            json.result.providerRoomCode
          );
        });
    } else {
      handleDisableDaysChange(
        currentDate,
        moment(currentDate).add(30, "days").format("YYYY-MM-DD"),
        adults,
        children,
        ""
      );
    }
  }, [pid]);
  const handleRoomListChange = (e) => {
    setRoomTypeCode(e.target.value);
    if (e.target.value !== "") {
      if (dates?.toDate && dates.toDate !== "")
        handleDisableDaysChange(
          dates.fromDate,
          dates.toDate,
          adults,
          children,
          e.target.value
        );
      else
        handleDisableDaysChange(
          currentDate,
          moment(currentDate).add(30, "days").format("YYYY-MM-DD"),
          adults,
          children,
          e.target.value
        );
    } else {
      if (dates?.toDate && dates.toDate !== "")
        handleDisableDaysChange(dates.fromDate, dates.toDate, adults, children, "");
      else
        handleDisableDaysChange(
          currentDate,
          moment(currentDate).add(30, "days").format("YYYY-MM-DD"),
          adults,
          children,
          ""
        );
    }
  }

  const handleAdultsChange = (e) => {
    setAdults(e.target.value);
    handleDisableDaysChange(
      currentDate,
      moment(currentDate).endOf("month").format("YYYY-MM-DD"),
      e.target.value,
      children,
      roomTypeCode
    );
  };

  const handleChildrenChange = (e) => {
    setChildren(e.target.value);
    if (data.bookingEngineUrl.includes("{CHILDREN_AGE}")) {
      let childrenValue = parseInt(e.target.value);
      let childrenAge = [...children_age];
      if (childrenAge.length > childrenValue) {
        let arr = [];
        for (var i = 0; i < childrenValue; i++) {
          arr.push(childrenAge[i]);
        }
        childrenAge = arr;
      } else {
        for (var i = childrenAge.length; i < childrenValue; i++) {
          childrenAge.push({
            id: i + 1,
            ["children_age_" + (i + 1)]: "",
          });
        }
      }
      setChildren_age(childrenAge);
    }
    handleDisableDaysChange(
      currentDate,
      moment(currentDate).endOf("month").format("YYYY-MM-DD"),
      adults,
      e.target.value,
      roomTypeCode
    );
  };

  const handleChangeChildrenAge = (e, id) => {
    let childrenAge = [...children_age];
    childrenAge = children_age.map((item) => {
      if (item.id === id) {
        return { ...item, [e.target.name]: e.target.value };
      } else {
        return { ...item };
      }
    });
    setChildren_age(childrenAge);
    //handleDisableDaysChange(currentDate,moment(currentDate).endOf('month').format('YYYY-MM-DD'),adults,children);
  };

  const handlePromoCodeChange = (e) => {
    setPromoCode(e.target.value);
  };

  const handleSelectedDayRange = (dates) => {
    setShowModel(false);
    if (
      disableCheckInDate.filter(
        (f) =>
          f.year == dates.from.year &&
          f.month == dates.from.month &&
          f.day == dates.from.day
      ).length > 0
    ) {
      setShowModel(true);
      setSelectedDayRange({ from: null, to: null });
      setDates(null);
    } else if (
      disableCheckInDate.filter(
        (f) =>
          f.year == dates.from.year &&
          f.month == dates.from.month &&
          f.day == dates.from.day &&
          f.year == dates.to.year &&
          f.month == dates.to.month &&
          f.day == dates.to.day
      ).length > 0
    ) {
      setShowModel(true);
      setSelectedDayRange({ from: null, to: null });
      setDates(null);
    } else if (
      disableDays.filter((f) => f.year == dates.from.year &&
        f.month == dates.from.month &&
        f.day == dates.from.day).length === 0 &&
      (dates.to === null
        ? true
        : disableDays.filter((f) => f.year == dates.to.year &&
          f.month == dates.to.month &&
          f.day == dates.to.day).length === 0)
    ) {
      setSelectedDayRange(dates);
      var fromDate = "";
      var toDate = "";
      if (dates.from !== null) {
        fromDate = moment({ year: dates.from.year, month: dates.from.month - 1, day: dates.from.day }).format("YYYY-MM-DD");
      }
      if (dates.to !== null) {
        toDate = moment({ year: dates.to.year, month: dates.to.month - 1, day: dates.to.day }).format("YYYY-MM-DD");
      }
      setDates({
        fromDate: fromDate, toDate: toDate
      });
      let night = 0;
      if (dates.from !== null && dates.to !== null) {
        let fromDateStr =
          dates.from.year + "-" + dates.from.month + "-" + dates.from.day;
        let toDateStr =
          dates.to.year + "-" + dates.to.month + "-" + dates.to.day;
        const fromDate = moment(fromDateStr).format("YYYY-MM-DD");
        const toDate = moment(toDateStr).format("YYYY-MM-DD");
        night = calculateNights(fromDate, toDate);
        if (datesData.length > 0) {
          const fromDateData = datesData.filter((f) => f.date === moment(fromDateStr).format('YYYY-MM-DD'));
          const toDateData = datesData.filter((f) => f.date === moment(toDateStr).format('YYYY-MM-DD'));
          if (fromDateData.length > 0 && toDateData.length > 0) {
            if (fromDateData[0]?.rate) {
              if (fromDateData[0].rate.ratePlanCode === toDateData[0].rate.ratePlanCode)
                setRatePlanCode(fromDateData[0].rate.ratePlanCode);
            } else if (fromDateData[0]?.ratePlanCode) {
              if (fromDateData[0].ratePlanCode === toDateData[0].ratePlanCode)
                setRatePlanCode(fromDateData[0].ratePlanCode);
            }
          }
          night = calculateNights(fromDate, toDate);
        }
      }

      setNights(night);
    }
  };

  const calculateNights = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    let dayCount = 0;
    while (end > start) {
      dayCount++;
      start.setDate(start.getDate() + 1);
    }
    return dayCount;
  };

  const submit = () => {
    if (data !== undefined) {
      // let fromDateStr =
      //   selectedDayRange.from.year +
      //   "-" +
      //   selectedDayRange.from.month +
      //   "-" +
      //   selectedDayRange.from.day;
      // let toDateStr =
      //   selectedDayRange.to.year +
      //   "-" +
      //   selectedDayRange.to.month +
      //   "-" +
      //   selectedDayRange.to.day;
      // const fromDate = moment(fromDateStr).format(data.dateFormat);
      // const toDate = moment(toDateStr).format(data.dateFormat);
      const fromDate = dates.fromDate;
      const toDate = dates.toDate;
      let childAge = "";
      let childrenAge = children_age;
      if (childrenAge.length > 0) {
        childrenAge.map((item, index) => {
          childAge += item["children_age_" + (index + 1)];
          if (item["children_age_" + (index + 1)] !== "" && childAge !== "" && childrenAge.length > (index + 1)) {
            childAge += data.delimiter;
          }
        });
      }
      let bookingUrl = data.bookingEngineUrl;
      if (children === 0) {
        if (bookingUrl.includes("{ADULTS}-{CHILDREN_AGE}")) {
          bookingUrl = bookingUrl.replace(
            "{ADULTS}-{CHILDREN_AGE}",
            "{ADULTS}{CHILDREN_AGE}"
          );
        }
      }
      bookingUrl = bookingUrl.replace("{CHECK_IN}", moment(fromDate).format(data.dateFormat));
      bookingUrl = bookingUrl.replace("{CHECK_OUT}", moment(toDate).format(data.dateFormat));
      bookingUrl = bookingUrl.replace("{ADULTS}", adults);
      bookingUrl = bookingUrl.replace("{CHILDREN}", children);
      bookingUrl = bookingUrl.replace("{LANGUAGE}", lang);
      bookingUrl = bookingUrl.replace(
        "{ROOM_TYPE}",
        data.roomBookingEngineCode
      );
      bookingUrl = bookingUrl.replace("{NIGHTS}", nights);
      bookingUrl = bookingUrl.replace("{CHILDREN_AGE}", childAge);
      bookingUrl = bookingUrl.replace("{PROMO_CODE}", promoCode);

      if (roomTypeCode !== "") {
        const hashIndex = bookingUrl.indexOf("#");
        bookingUrl = bookingUrl.slice(0, hashIndex)
          + "&roomtypeid=" + roomTypeCode + bookingUrl.slice(hashIndex);
      }
      if (ratePlanCode !== "") {
        const hashIndex = bookingUrl.indexOf("#");
        bookingUrl = bookingUrl.slice(0, hashIndex)
          + "&rateplanid=" + ratePlanCode + bookingUrl.slice(hashIndex);
      }

      var body = {
        groupId: data.gid,
        propertyId: data.pid,
        checkInDate: moment(fromDate).format("YYYY-MM-DD"),
        checkOutDate: toDate !== "" ? moment(toDate).format("YYYY-MM-DD") : "",
        nights: nights,
        adults: adults,
        childrens: children,
        creator: "webview",
        promoCode: promoCode,
      };
      let msg = "Customer referred to the booking page for dates";
      msg +=
        " " +
        months[selectedDayRange.from.month - 1] +
        " " +
        selectedDayRange.from.day +
        ", " +
        selectedDayRange.from.year +
        " to " +
        months[selectedDayRange.to.month - 1] +
        " " +
        selectedDayRange.to.day +
        ", " +
        selectedDayRange.to.year +
        "";
      if (adults !== 0) {
        msg += ", for " + adults + " adults";
      }
      if (children !== 0) {
        msg += " and " + children + " children";
      }
      api.sendActivity({
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "webchat/booking",
          value: {
            msg: `${msg}`,
          },
        },
      });
      fetch(`${BMB_BOOKING_ENGINE}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      addLinks(bookingUrl);
      closeAvailblityForm();
      if (window.parent) {
        window.parent.postMessage("openUrl:" + bookingUrl + "", "*");
      } else {
        window.location = bookingUrl;
      }
    }
  };

  return (
    <Fragment>
      <div className="chat_box_popup_new">
        <div className="endchat_popup area">
          <h1 className="availablityh1">
            {""}
            {roomdata && roomdata.length > 0 ?
              <Fragment>
                <Input style={{width:'90%'}}
                  type="select"
                  name="roomTypeCode"
                  value={roomTypeCode == "" ? "" : roomdata.filter(f => f.providerRoomCode == roomTypeCode)[0].providerRoomCode}
                  onChange={(e) => handleRoomListChange(e)}
                >
                  <option value={""}>All</option>
                  {roomdata.map((item, i) => (
                    <option key={item.providerRoomCode} value={item.providerRoomCode}>{item.name}</option>
                  ))}
                </Input>
              </Fragment> : <IntlMessages id="check.availabity" />}
            {""}
              <img style={{float: 'right', top: '20px', position: 'absolute', right: '4px'}}  onClick={closeAvailblityForm} src="/res/cross_icon.jpg" width="15" height="15" />
          </h1>
          <Row>
            <Col xs={12}>
              <Calendar
                value={selectedDayRange}
                minimumDate={minimumDate}
                disabledDays={disableDays}
                onChange={handleSelectedDayRange}
                style={{ height: "32.7em" }}
                renderFooter={() => (
                  <Fragment>
                    {loading === true && (
                      <div id="spinner" className="container-load">
                        <div className="loading"></div>
                      </div>
                    )}
                    {showModel === true && (
                      <div
                        className="d-flex justify-content-center py-3"
                        style={{
                          background: "red",
                          color: "white",
                          fontSize: "0.85rem",
                        }}
                      >
                        This date is unavailable as a Check-in date.
                      </div>
                    )}
                  </Fragment>
                )}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs={6} style={{ margin: "0" }}>
              <FormGroup>
                <Label>
                  <IntlMessages id="check.availabity.adults" />
                </Label>
                <Input
                  id="roomCode"
                  type="hidden"
                  name="roomcode"
                  value={roomTypeCode}
                ></Input>
                <Input
                  id="adult_count"
                  type="select"
                  name="adults"
                  value={adults}
                  onChange={handleAdultsChange}
                >
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                </Input>
              </FormGroup>
            </Col>
            <Col xs={6} style={{ margin: "0" }}>
              <FormGroup>
                <Label>
                  <IntlMessages id="check.availabity.children" />
                </Label>
                <Input
                  id="children_count"
                  type="select"
                  name="children"
                  value={children}
                  onChange={handleChildrenChange}
                >
                  <option>0</option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                </Input>
              </FormGroup>
            </Col>
            {children_age.length > 0 &&
              children_age.map((element, i) => (
                <Col xs={4} style={{ margin: "0" }} key={i}>
                  <FormGroup>
                    <Label>
                      <IntlMessages id="check.availabity.child.age" /> {i + 1}
                    </Label>
                    <Input
                      type="select"
                      name={"children_age_" + (i + 1)}
                      value={element[i]}
                      onChange={(e) => handleChangeChildrenAge(e, element.id)}
                    >
                      <option>0</option>
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                      <option>4</option>
                      <option>5</option>
                      <option>6</option>
                      <option>7</option>
                      <option>8</option>
                      <option>9</option>
                      <option>10</option>
                      <option>11</option>
                      <option>12</option>
                    </Input>
                  </FormGroup>
                </Col>
              ))}
          </Row>
          {data.bookingEngineUrl.includes("{PROMO_CODE}") && (
            <Row>
              <Col xs={12} style={{ margin: "0" }} className="mb-3">
                <Input
                  type="text"
                  value={promoCode}
                  placeholder={"Promo Code"}
                  onChange={handlePromoCodeChange}
                />
              </Col>
            </Row>
          )}
          {selectedDayRange.from !== null && selectedDayRange.to !== null ? (
            <button className="availablity_button"
              style={{ backgroundColor: buttonColor ? buttonColor : '#0eca2d', borderColor: buttonColor ? buttonColor : '#0eca2d' }}
              // style={{ backgroundColor: '#0eca2d' }}
              onClick={submit}>
              {""}
              Book Now
              {""}
            </button>
          ) : (
            <button
              className="availablity_button"
              style={{ backgroundColor: buttonColor ? buttonColor : '#0eca2d', borderColor: buttonColor ? buttonColor : '#0eca2d' }}
            //  style={{ background: "#0eca2d" }}
            >
              {""}
              Book Now
              {""}
            </button>
          )}
          <button className="cancelchat_button" onClick={closeAvailblityForm}>
            {""}
            <IntlMessages id="check.availabity.cancel" />
            {""}
          </button>
        </div>
      </div>
    </Fragment>
  );
}

export default AmaduesAvailability;
